import listToTree from 'list-to-tree-lite'
import _ from 'lodash'

// build a tree based on id and parent_id of list
// @param providerInterests [Array<Object>]
// @return [Array<Object>] or empty array
function buildTree(list) {
  if (typeof list === 'undefined') return []

  return listToTree(list, {
    idKey: 'id',
    parentKey: 'parent_id'
  })
}

function findParents(node, list) {
  if (_.isNil(node.parent_id)) {
    return []
  } else {
    const parent = _.find(list, ['id', node.parent_id])

    if (_.isNil(parent)) {
      throw new Error('parent not found')
    } else {
      return _.flatten([parent, findParents(parent, list)])
    }
  }
}

function buildProviderTrees(nodes) {
  const { vk, google, targetMail, facebook } = _.groupBy(nodes, (node) => node.provider)

  return [...buildTree(vk), ...buildTree(google), ...buildTree(targetMail), ...buildTree(facebook)]
}

function searchStringMatcher(searchString) {
  const lowercasedSearchString = searchString.toLowerCase()
  return (sourceString) => {
    return sourceString.toLowerCase().indexOf(lowercasedSearchString) > -1
  }
}

export default {
  buildTree,
  findParents,
  buildProviderTrees,
  searchStringMatcher
}
